import { Router } from "@angular/router";
import { Component, OnInit, ViewEncapsulation } from "@angular/core";

import { AuthenticationService } from "./_services/authentication.service";
import { UrlRedirectService } from "./_services/url-redirect.service";

declare let gtag: Function;

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class AppComponent implements OnInit {
  currentUser: any;

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private urlRedirectService: UrlRedirectService,
  ) {
    this.authenticationService.currentUser.subscribe(
      (x) => (this.currentUser = x),
    );
    //todo: do we need to change this to throw just in load map route nor in each route change
    // this.router.events.subscribe((event) => {
    //   if (event instanceof NavigationEnd) {
    //     console.log('router event');
    //     gtag("config", environment.gaTrackId, {
    //       page_path: event.urlAfterRedirects,
    //     });
    //   }
    // });
  }

  ngOnInit() {
    this.urlRedirectService.handleInitialRedirect();

    // sends the current URL in case the viewer is inside an iFrame
    if (window.parent) {
      window.parent.postMessage({ url: window.location.href }, "*");
    }
  }

  logout() {
    this.router.navigate(["/"]);
  }
}
